import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ISearchContractResponse } from '../../../interfaces/ISearchContract';
import { DataService } from '../../../services/data/data.service';
import { RouterService } from '../../../services/router/router.service';
import { SearchPlanService } from '../../../services/searchPlan/searchPlanService.service';
import { UtilitiesService } from '../../../services/utilities/utilities.service';
import { APP_ROUTES } from '../../../utils/route.constant';
import { ACC_LOGGEDIN, ACC_LOGGEDOUT, ALL_PAGES, ERR_EVENT, INCORRECT_INFO_PHONE_NUMBER, NO_PLAN_FOUND_MESSAGE, PLAN_FOUND_PAGE } from '../../../services/ga4/ga4.constant';
import { trackByIndex } from '../../../utils/helper';
import { Ga4Service } from '../../../services/ga4/ga4.service';

@Component({
  selector: 'app-plan-found-shared',
  templateUrl: './plan-found.component.html',
  styleUrl: './plan-found.component.scss'
})
export class PlanFoundComponent implements OnInit, OnDestroy {
  cleaner$ = new Subject<void>;
  plans: ISearchContractResponse[] = [];
  selectedPlan: ISearchContractResponse | null = null;
  selectedPlanMultiple: ISearchContractResponse[] = [];
  auth0Id: string='';
  contactNumFormatted: string='';
  allPlanSelected = false;
  planFoundPage = PLAN_FOUND_PAGE;
  incorrectInfoPhoneNumber = INCORRECT_INFO_PHONE_NUMBER;
  trackByIndex = trackByIndex;
  private noPlansEventFired = false;
  constructor(
    private searchPlanService: SearchPlanService,
    private routerService: RouterService,
    private dataService:DataService,
    private utilService:UtilitiesService,
    private ga4Service:Ga4Service
  ) { }


  ngOnInit(): void {
    this.auth0Id=this.dataService.auth0UserId.getValue();
    this.searchPlanService.plans$.pipe(takeUntil(this.cleaner$)).subscribe((plans) => {
      this.plans = [...plans];
      if (plans.length === 0 && !this.noPlansEventFired) {
        this.noPlansEventFired = true;
        this.ga4Service.messageEvent(
          ERR_EVENT,
          NO_PLAN_FOUND_MESSAGE,
          ALL_PAGES
        );
      }
      // Reset when plans come back
      if (plans.length > 0) {
        this.noPlansEventFired = false;
      }
      // Auto-select logic
      if ((!this.auth0Id && this.plans.length === 1) || (this.auth0Id && this.plans.length === 1 && !plans[0].alreadyLinked)) {
        this.selectPlan(this.plans[0]);
      } else {
        this.selectedPlan = null;
      }
      // (!this.auth0Id && this.plans.length === 1) || (this.auth0Id && this.plans.length === 1 && !plans[0].alreadyLinked )
      //   ? this.selectPlan(this.plans[0])
      //   : this.selectedPlan = null;
      
      // Contact number logic
      if(this.auth0Id && this.plans){
        let contactNumber = this.utilService.getContactNumber(this.plans[0]);
        this.contactNumFormatted = this.utilService.formatPhone(contactNumber);
      }
    })
  }

  selectPlan(plan: any): void {
    //for registration
    if (!this.auth0Id) {
      //select and deselect logic for multiple 
      const index = this.selectedPlanMultiple.findIndex(p => p.contractNumber === plan.contractNumber);
      if (index !== -1) { 
        this.selectedPlanMultiple.splice(index, 1);
        this.allPlanSelected = false;
      } else {
        this.selectedPlanMultiple.push(plan);
      }
      if (this.selectedPlanMultiple.length === this.plans.length) {
        this.selectAllPlans();
      }
    } else {
      this.selectedPlan = plan;
    }
  }

  highlightSelectedPlan(contractNumber: string): boolean {
    if (!this.auth0Id) {
      const index = this.selectedPlanMultiple.findIndex(p => p.contractNumber === contractNumber);
     if (index !== -1) { 
        return true;
      } else {
        return false;
      }
    } else {
      return this.selectedPlan?.contractNumber === contractNumber;
    }
  }  

  selectAllPlans() {
    if (!this.allPlanSelected) {
      this.selectedPlanMultiple = [...this.plans];
      this.allPlanSelected = true;
    } else {
      this.selectedPlanMultiple = [];
      this.allPlanSelected = false;
    }    
  }

  goForward(): void {
    if (this.selectedPlanMultiple.length && !this.auth0Id) {
      this.searchPlanService.selectedPlanMultiple$.next(this.selectedPlanMultiple);
      this.routerService.goto(APP_ROUTES.CREATE_ACCOUNT);
    }else if (this.selectedPlan && this.auth0Id){
      this.searchPlanService.selectedPlan$.next(this.selectedPlan);
      this.routerService.goto(APP_ROUTES.LINK_PLAN);
    }
  }

  isLinkButtonHidden(): boolean{
    return !(this.auth0Id !== '' && this.plans.length === 1 && this.plans[0]?.alreadyLinked);
  }

  goBack(): void {
    this.routerService.goto(this.auth0Id?APP_ROUTES.FIND_PLAN:APP_ROUTES.REGISTER);
  }

  ngOnDestroy(): void {
    this.cleaner$.next();
    this.cleaner$.complete();
  }

}
